<template>
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
        <div class="modal-header">
            <slot name="header">
              로그인
            </slot>
        </div>
        <p class="loading-message" v-show="answer">{{answer}}</p>
        <div class="first-flex">
        <input type="email" v-model="question" class="inputfirst" placeholder="input your email"/>
        </div>
        <div class="first-foot">
        <button v-if='isfirst' class="isfirst-btn" @click="$emit('close')">close</button>
        <router-link v-else class="isfirst-btn" to="/beforetuto" @click.native.prevent="loaduserinfo">Enter</router-link>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
/* eslint-disable */
export default {
  data () {
    return {
        isfirst: true,
        login_email: '',
        question: '',
        answer: '이메일을 입력하여 로그인을 해주세요.',
        headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
      }
    }
  },
  watch: {
    // 질문이 변경될 때 마다 이 기능이 실행됩니다.
    question: function (newQuestion) {
      this.answer = '입력을 기다리는 중...'
      this.getAnswer()
    }
  },
  methods: {
    loaduserinfo () {
      this.$store.dispatch('loadUserinfo')
    },
    // _.debounce는 lodash가 제공하는 기능으로
    // 특히 시간이 많이 소요되는 작업을 실행할 수 있는 빈도를 제한합니다.
    // 이 경우, 우리는 api 에 액세스 하는 빈도를 제한하고,
    // 사용자가 ajax요청을 하기 전에 타이핑을 완전히 마칠 때까지 기다리길 바랍니다.
    // _.debounce 함수(또는 이와 유사한 _.throttle)에 대한
    // 자세한 내용을 보려면 https://lodash.com/docs#debounce 를 방문하세요.
    getAnswer: _.debounce(
      function () {
        if (this.question.indexOf('@') === -1) {
          this.answer = '이메일에는 일반적으로 "@"가 포함된다는 사실...아시죠?'
          return
        }
        this.answer = '검색중...'
        var vm = this
        axios.get(`http://dokdo.nolple.com:8000/session/login/${this.question}`, {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
      })
          .then(function (response) {
            if (response.data.result == 0){
              vm.isfirst = true
              vm.answer = '등록된 이메일이 없습니다. 새 게임을 눌러주세요.'
            }
            else{
              vm.isfirst = false
              vm.answer = '아래의 Enter버튼을 눌러 게임을 시작하세요.'
              vm.$store.commit('SetPlayerid', response.data.result)
            }
          })
          .catch(function (error) {
            vm.isfirst = true
            vm.answer = '에러! API 요청에 오류가 있습니다. ' + error
          })
      },
      // 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
      800
    )
  }
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  border: black solid 5px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header{
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1.5em;
}

.modal-body {
  margin: 10px 0;
}

.modal-default-button {
  display: block;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1.5em;
  width: 100%;
  border: none;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue